(function(){

    var prevScrollpos = window.pageYOffset;
    window.onscroll = function() {
        var currentScrollPos = window.pageYOffset;
        if (prevScrollpos > currentScrollPos) {
            document.getElementById("header").style.top = "0";
        } else {
            document.getElementById("header").style.top = "-110px";
        }
        prevScrollpos = currentScrollPos;
    }



    /* ====== Mobile Menu (single container, TUX-like) ====== */
    const modal  = document.getElementById('mm-modal');
    const toggle = document.getElementById('mm-mobile-toggle');
    const close  = document.getElementById('mm-mobile-close');
    if(!modal || !toggle || !close) return;

    const inner  = modal.querySelector('.mm-inner');
    const child  = modal.querySelector('.mm-child');
    const header = modal.querySelector('.mm-header');
    const logo   = modal.querySelector('.mm-logo');
    const sec    = modal.querySelector('.mm-secondary');
    const footer = modal.querySelector('.mm-footer');
    const list   = modal.querySelector('.mm-links');
    const bg     = modal.querySelector('.mm-bg');

    const EASE = {
        panel: 'cubic-bezier(0.9,0,0.1,1)',     // come TUX
        out:   'cubic-bezier(0.4,0,1,1)',       // easeIn-ish
        in:    'cubic-bezier(0.16,1,0.3,1)'     // expo-out-ish
    };
    const T = {
        panel: 1000,   // up/down pannello
        itemsIn: 820,
        itemsOut: 480,
        stagger: 90
    };

    // Helpers
    let lastFocused = null;
    const focusableSelectors = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';
    let focusables = [];

    function lockScroll(lock){
        document.documentElement.style.overflow = document.body.style.overflow = lock ? 'hidden' : '';
        document.body.style.touchAction = lock ? 'none' : '';
    }
    function setAria(expanded){
        toggle.setAttribute('aria-expanded', String(expanded));
        modal.setAttribute('aria-hidden', String(!expanded));
    }
    function collectSpans(){
        const spans = [];
        list?.querySelectorAll('a').forEach(a=>{
            // wrap se non presente
            if(!a.querySelector('span')) a.innerHTML = '<span>'+a.innerHTML+'</span>';
            spans.push(a.querySelector('span'));
        });
        return spans;
    }

    // === OPEN
    function openMenu(){
        if (modal.classList.contains('is-active')) return;
        lastFocused = document.activeElement;

        // Stato iniziale
        modal.classList.add('is-active');
        setAria(true);
        lockScroll(true);

        focusables = Array.from(modal.querySelectorAll(focusableSelectors));
        (focusables[0] || close || toggle)?.focus();

        // PANNELLO: inner sale dal basso; child entra dall’alto (contromovimento)
        inner.animate(
            [{transform:'translate3d(0,100%,0)'},{transform:'translate3d(0,0,0)'}],
            {duration:T.panel, easing:EASE.panel, fill:'forwards'}
        );
        child.animate(
            [{transform:'translate3d(0,-100%,0)'},{transform:'translate3d(0,0,0)'}],
            {duration:T.panel, easing:EASE.panel, fill:'forwards'}
        );

        // HEADER / LOGO
        [header, logo].forEach((el,i)=>{
            if(!el) return;
            el.animate(
                [{opacity:0, transform:'translateY(10px)'},
                    {opacity:1, transform:'translateY(0)'}],
                {duration:500, easing:EASE.in, delay: 600 + i*80, fill:'forwards'}
            );
        });

        // VOCI: translateY(60%) -> 0 con stagger
        const spans = collectSpans();
        spans.forEach((el,i)=>{
            el.animate(
                [{transform:'translateY(110%)', opacity:0, filter:'blur(6px)'},
                    {transform:'translateY(0)',   opacity:1, filter:'blur(0)'}],
                {duration:T.itemsIn, easing:EASE.in, delay: 680 + i*T.stagger, fill:'forwards'}
            );
        });

        // Secondari & Footer
        [sec, footer].forEach((el,i)=>{
            if(!el) return;
            el.animate(
                [{opacity:0, transform:'translateY(12px)'},
                    {opacity:1, transform:'translateY(0)'}],
                {duration:520, easing:EASE.in, delay: 680 + spans.length*T.stagger + 100 + i*60, fill:'forwards'}
            );
        });
    }

    // === CLOSE
    function closeMenu(){
        if (!modal.classList.contains('is-active')) return;

        // Nascondi subito header/logo/sec/footer (nessun residuo)
        [header, logo, sec, footer].forEach(el=>{
            if(!el) return;
            el.animate(
                [{opacity:1, transform:'translateY(0)'},
                    {opacity:0, transform:'translateY(10px)'}],
                {duration:220, easing:EASE.out, fill:'forwards'}
            );
        });

        // Voci out (reverse, compatte)
        const spans = collectSpans();
        spans.slice().reverse().forEach((el,idx)=>{
            el.animate(
                [{transform:'translateY(0)', opacity:1, filter:'blur(0)'},
                    {transform:'translateY(22px)', opacity:0, filter:'blur(6px)'}],
                {duration:T.itemsOut, easing:EASE.out, delay: idx*40, fill:'forwards'}
            );
        });

        // PANNELLO: scende (inner 0->100%), child sale (0->-100%)
        const panelDelay = 120;
        setTimeout(()=>{
            inner.animate(
                [{transform:'translate3d(0,0,0)'},{transform:'translate3d(0,100%,0)'}],
                {duration:T.panel, easing:EASE.panel, fill:'forwards'}
            );
            child.animate(
                [{transform:'translate3d(0,0,0)'},{transform:'translate3d(0,-100%,0)'}],
                {duration:T.panel, easing:EASE.panel, fill:'forwards'}
            );
        }, panelDelay);

        // Cleanup finale (niente flash)
        const total = Math.max(T.itemsOut + spans.length*40, panelDelay + T.panel) + 60;
        setTimeout(()=>{
            // reset stato base invisibile
            [header, logo, sec, footer].forEach(el=>{
                if(!el) return;
                el.style.opacity = '0';
                el.style.transform = '';
            });
            inner.style.transform = '';
            child.style.transform = '';

            modal.classList.remove('is-active');
            setAria(false);
            lockScroll(false);
            (lastFocused || toggle).focus();
        }, total);
    }

    // API globale (facoltativa, utile se devi aprire da altri script)
    window.MMMenu = {
        open:  () => openMenu(),
        close: () => closeMenu(),
        toggle: () => (modal.classList.contains('is-active') ? closeMenu() : openMenu())
    };

    // Events
    toggle.addEventListener('click', ()=> modal.classList.contains('is-active') ? closeMenu() : openMenu());
    close.addEventListener('click', closeMenu);
    bg.addEventListener('click', closeMenu);

    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && modal.classList.contains('is-active')) { e.preventDefault(); closeMenu(); }
        if (e.key === 'Tab' && modal.classList.contains('is-active')) {
            const focusables = Array.from(modal.querySelectorAll(focusableSelectors));
            if (!focusables.length) return;
            const first = focusables[0], last = focusables[focusables.length-1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        }
    });

    // === Extra triggers: classi e data-attribute ===
    // Supporta: .js-menu-open / .js-menu-close / .js-menu-toggle
    // [data-menu="open|close|toggle"]
    document.addEventListener('click', (e) => {
        const t = e.target.closest('.js-menu-open, .js-menu-close, .js-menu-toggle, [data-menu]');
        if (!t) return;

        // Se è un link evita il salto pagina
        if (t.tagName === 'A') e.preventDefault();

        const action = t.dataset.menu
            || (t.classList.contains('js-menu-open')   ? 'open'
                :  t.classList.contains('js-menu-close')  ? 'close'
                    :  t.classList.contains('js-menu-toggle') ? 'toggle'
                        :  null);

        if (!action) return;

        if (action === 'open')   { openMenu(); }
        if (action === 'close')  { closeMenu(); }
        if (action === 'toggle') { modal.classList.contains('is-active') ? closeMenu() : openMenu(); }
    });
})();
